import React from 'react';
import styled from 'styled-components';

import CtaLink from '../../common/ui/CtaLink';

const Content = () => (
  <Wrapper>
    <Subtitle>Supporting wineries like you</Subtitle>
    <Title>Customers</Title>
    <Text>
      Commerce7 enables wineries around the world, regardless of size, to
      succeed by empowering them with the digital tools needed to create
      customer-centric shopping experiences.
    </Text>
    <CtaLink color="var(--blue-base)" to="/demo">
      Schedule a demo
    </CtaLink>
  </Wrapper>
);

const Wrapper = styled.div`
  text-align: center;
  margin-bottom: 215px;
`;

const Subtitle = styled.h3`
  color: var(--gray-dark);
  font-size: var(--font-size-lg);
  letter-spacing: var(--letter-spacing-base);
  margin-bottom: 5px;
`;

const Title = styled.h1`
  color: var(--blue-dark);
  line-height: var(--line-height-sm);
  font-size: var(--heading-size-xl);
  font-weight: var(--font-weight-black);
  margin-bottom: 30px;

  ${({ theme }) => `
  @media ${theme.mediumUp} {
    font-size: var(--heading-size-2xl);
    line-height: var(--line-height-sm);
  }
  `}
`;

const Text = styled.p`
  font-size: var(--font-size-lg);

  max-width: 900px;
  margin: 0 auto 25px;
`;

export default Content;
